var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "overflow-x-hidden overflow-y-auto fixed inset-0 top-0 left-0 outline-none focus:outline-none justify-center items-center flex",
        class: _vm.isShowingModal ? "z-50" : "opacity-0 pointer-events-none"
      },
      [
        _c("div", { class: _vm.getCssSize }, [
          _c(
            "div",
            {
              staticClass:
                "border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t"
                },
                [
                  _c("h3", { staticClass: "text-2xl font-semibold" }, [
                    _vm._v(
                      "\n            " + _vm._s(_vm.title) + "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      on: {
                        click: function($event) {
                          return _vm.toggleModal()
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none"
                        },
                        [_vm._v("\n              ×\n            ")]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm._t("body"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.toggleModal()
                        }
                      }
                    },
                    [_vm._v("\n            Cancel\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "bg-blue-700 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.labelSaveButton) +
                          "\n          "
                      )
                    ]
                  )
                ]
              )
            ],
            2
          )
        ])
      ]
    ),
    _vm._v(" "),
    _vm.isShowingModal
      ? _c("div", { staticClass: "opacity-25 fixed inset-0 z-40 bg-black" })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4660a5c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4660a5c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/ModalDialog.vue
// module id = null
// module chunks = 